module.exports = __webpack_public_path__ + "static/img/szafa_18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_18.jpg
// module id = IwuN
// module chunks = 0